var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDailyThirdPrice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Circle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9983 43.9967C38 43.9967 44.9967 34.5954 44.9967 22.9983C44.9967 11.4013 38 2 23.9983 2C9.99665 2 3 11.4013 3 22.9983C3 34.5954 9.99665 43.9967 23.9983 43.9967Z",
    fill: "url(#paint0_radial_592_6619)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9983 43.9967C38 43.9967 44.9967 34.5954 44.9967 22.9983C44.9967 11.4013 38 2 23.9983 2C9.99665 2 3 11.4013 3 22.9983C3 34.5954 9.99665 43.9967 23.9983 43.9967Z",
    fill: "url(#paint1_radial_592_6619)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9983 43.9967C38 43.9967 44.9967 34.5954 44.9967 22.9983C44.9967 11.4013 38 2 23.9983 2C9.99665 2 3 11.4013 3 22.9983C3 34.5954 9.99665 43.9967 23.9983 43.9967Z",
    fill: "url(#paint2_radial_592_6619)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9983 43.9967C38 43.9967 44.9967 34.5954 44.9967 22.9983C44.9967 11.4013 38 2 23.9983 2C9.99665 2 3 11.4013 3 22.9983C3 34.5954 9.99665 43.9967 23.9983 43.9967Z",
    fill: "url(#paint3_radial_592_6619)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9983 43.9967C38 43.9967 44.9967 34.5954 44.9967 22.9983C44.9967 11.4013 38 2 23.9983 2C9.99665 2 3 11.4013 3 22.9983C3 34.5954 9.99665 43.9967 23.9983 43.9967Z",
    fill: "url(#paint4_radial_592_6619)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9983 43.9967C38 43.9967 44.9967 34.5954 44.9967 22.9983C44.9967 11.4013 38 2 23.9983 2C9.99665 2 3 11.4013 3 22.9983C3 34.5954 9.99665 43.9967 23.9983 43.9967Z",
    fill: "url(#paint5_radial_592_6619)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9983 43.9967C38 43.9967 44.9967 34.5954 44.9967 22.9983C44.9967 11.4013 38 2 23.9983 2C9.99665 2 3 11.4013 3 22.9983C3 34.5954 9.99665 43.9967 23.9983 43.9967Z",
    fill: "url(#paint6_radial_592_6619)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9983 43.9967C38 43.9967 44.9967 34.5954 44.9967 22.9983C44.9967 11.4013 38 2 23.9983 2C9.99665 2 3 11.4013 3 22.9983C3 34.5954 9.99665 43.9967 23.9983 43.9967Z",
    fill: "url(#paint7_radial_592_6619)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9983 43.9967C38 43.9967 44.9967 34.5954 44.9967 22.9983C44.9967 11.4013 38 2 23.9983 2C9.99665 2 3 11.4013 3 22.9983C3 34.5954 9.99665 43.9967 23.9983 43.9967Z",
    fill: "url(#paint8_radial_592_6619)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9983 43.9967C38 43.9967 44.9967 34.5954 44.9967 22.9983C44.9967 11.4013 38 2 23.9983 2C9.99665 2 3 11.4013 3 22.9983C3 34.5954 9.99665 43.9967 23.9983 43.9967Z",
    fill: "url(#paint9_radial_592_6619)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9983 43.9967C38 43.9967 44.9967 34.5954 44.9967 22.9983C44.9967 11.4013 38 2 23.9983 2C9.99665 2 3 11.4013 3 22.9983C3 34.5954 9.99665 43.9967 23.9983 43.9967Z",
    fill: "url(#paint10_radial_592_6619)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9983 43.9967C38 43.9967 44.9967 34.5954 44.9967 22.9983C44.9967 11.4013 38 2 23.9983 2C9.99665 2 3 11.4013 3 22.9983C3 34.5954 9.99665 43.9967 23.9983 43.9967Z",
    fill: "url(#paint11_radial_592_6619)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9983 43.9967C38 43.9967 44.9967 34.5954 44.9967 22.9983C44.9967 11.4013 38 2 23.9983 2C9.99665 2 3 11.4013 3 22.9983C3 34.5954 9.99665 43.9967 23.9983 43.9967Z",
    fill: "url(#paint12_radial_592_6619)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9983 43.9967C38 43.9967 44.9967 34.5954 44.9967 22.9983C44.9967 11.4013 38 2 23.9983 2C9.99665 2 3 11.4013 3 22.9983C3 34.5954 9.99665 43.9967 23.9983 43.9967Z",
    fill: "url(#paint13_radial_592_6619)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9983 43.9967C38 43.9967 44.9967 34.5954 44.9967 22.9983C44.9967 11.4013 38 2 23.9983 2C9.99665 2 3 11.4013 3 22.9983C3 34.5954 9.99665 43.9967 23.9983 43.9967Z",
    fill: "url(#paint14_radial_592_6619)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9983 43.9967C38 43.9967 44.9967 34.5954 44.9967 22.9983C44.9967 11.4013 38 2 23.9983 2C9.99665 2 3 11.4013 3 22.9983C3 34.5954 9.99665 43.9967 23.9983 43.9967Z",
    fill: "url(#paint15_radial_592_6619)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Eye",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1579 14.8473C33.845 14.428 33.3264 13.9926 32.3082 14.0001C31.2781 14.0077 30.7663 14.4484 30.4657 14.8569C30.2996 15.0826 30.1904 15.3149 30.1238 15.4924C30.0912 15.5793 30.0709 15.6474 30.0601 15.6872C30.0552 15.7049 30.0524 15.7166 30.0513 15.7212C29.8857 16.5247 29.1037 17.0473 28.2962 16.8904C27.483 16.7324 26.9518 15.945 27.1099 15.1318C27.1652 14.8999 27.1652 14.8999 27.1652 14.8999C27.1975 14.7813 27.2457 14.6231 27.3151 14.4382C27.4525 14.0723 27.6809 13.5796 28.0495 13.0787C28.8182 12.0341 30.1639 11.0159 32.2861 11.0002C34.4203 10.9844 35.7825 12.008 36.5624 13.0535C36.9369 13.5554 37.1716 14.0508 37.3136 14.4184C37.3854 14.6041 37.4357 14.7631 37.4695 14.8821C37.6692 15.5854 37.3855 16.6751 36.3632 16.8869C35.5574 17.0539 34.7686 16.5405 34.5935 15.7385C34.5923 15.7337 34.5891 15.721 34.5836 15.7014C34.5717 15.6597 34.5498 15.589 34.5152 15.4994C34.4444 15.3163 34.3298 15.0778 34.1579 14.8473Z",
    fill: "url(#paint16_radial_592_6619)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Eye_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.611 14.8473C17.2981 14.428 16.7795 13.9926 15.7614 14.0001C14.7312 14.0077 14.2194 14.4484 13.9189 14.8569C13.7527 15.0826 13.6436 15.3149 13.5769 15.4924C13.5443 15.5793 13.524 15.6474 13.5132 15.6872C13.5084 15.7049 13.5056 15.7166 13.5045 15.7212C13.3388 16.5247 12.5568 17.0473 11.7493 16.8904C10.9361 16.7324 10.4049 15.945 10.563 15.1318C10.6183 14.8999 10.6183 14.8999 10.6183 14.8999C10.6506 14.7813 10.6989 14.6231 10.7682 14.4382C10.9056 14.0723 11.134 13.5796 11.5026 13.0787C12.2714 12.0341 13.617 11.0159 15.7392 11.0002C17.8734 10.9844 19.2356 12.008 20.0156 13.0535C20.39 13.5554 20.6247 14.0508 20.7667 14.4184C20.8385 14.6041 20.8889 14.7631 20.9226 14.8821C21.1223 15.5854 20.8387 16.6751 19.8163 16.8869C19.0105 17.0539 18.2218 16.5405 18.0466 15.7385C18.0454 15.7337 18.0422 15.721 18.0367 15.7014C18.0248 15.6597 18.0029 15.589 17.9683 15.4994C17.8975 15.3163 17.7829 15.0778 17.611 14.8473Z",
    fill: "url(#paint17_radial_592_6619)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Mouth",
    d: "M24 38C9 38 9 23 9 23H39C39 23 39 38 24 38Z",
    fill: "url(#paint18_radial_592_6619)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Teeth"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7588 29.2942L10.5 23H37.5L36.2412 29.2942C36.1009 29.9953 35.4853 30.5 34.7703 30.5H13.2297C12.5147 30.5 11.8991 29.9953 11.7588 29.2942Z",
    fill: "url(#paint19_radial_592_6619)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7588 29.2942L10.5 23H37.5L36.2412 29.2942C36.1009 29.9953 35.4853 30.5 34.7703 30.5H13.2297C12.5147 30.5 11.8991 29.9953 11.7588 29.2942Z",
    fill: "url(#paint20_linear_592_6619)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5143 33.0732C14.7006 35.7936 18.2471 38 24 38C29.752 38 33.2983 35.7943 35.4847 33.0745L35.7604 31.6961C35.8842 31.0773 35.4109 30.5 34.7798 30.5H13.2195C12.5884 30.5 12.1151 31.0773 12.2389 31.6961L12.5143 33.0732Z",
    fill: "url(#paint21_linear_592_6619)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector 776"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.1884 30.0725L39.6764 34.3223L36.1667 35.3204C33.7424 34.5182 32.3144 32.9762 31.4536 31.3913C31.0905 30.7229 31.0935 29.4951 32.5363 29.4951H36.1814C36.5957 29.4951 36.979 29.7149 37.1884 30.0725Z",
    fill: "#4686EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1884 30.0725L39.6764 34.3223L36.1667 35.3204C33.7424 34.5182 32.3144 32.9762 31.4536 31.3913C31.0905 30.7229 31.0935 29.4951 32.5363 29.4951H36.1814C36.5957 29.4951 36.979 29.7149 37.1884 30.0725Z",
    fill: "url(#paint22_radial_592_6619)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1884 30.0725L39.6764 34.3223L36.1667 35.3204C33.7424 34.5182 32.3144 32.9762 31.4536 31.3913C31.0905 30.7229 31.0935 29.4951 32.5363 29.4951H36.1814C36.5957 29.4951 36.979 29.7149 37.1884 30.0725Z",
    fill: "url(#paint23_linear_592_6619)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector 777"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3923 30.0725L36.9043 34.3223L40.414 35.3204C42.8383 34.5182 44.2663 32.9762 45.1271 31.3913C45.4902 30.7229 45.4872 29.4951 44.0444 29.4951H40.3993C39.985 29.4951 39.6017 29.7149 39.3923 30.0725Z",
    fill: "#4686EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3923 30.0725L36.9043 34.3223L40.414 35.3204C42.8383 34.5182 44.2663 32.9762 45.1271 31.3913C45.4902 30.7229 45.4872 29.4951 44.0444 29.4951H40.3993C39.985 29.4951 39.6017 29.7149 39.3923 30.0725Z",
    fill: "url(#paint24_radial_592_6619)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3923 30.0725L36.9043 34.3223L40.414 35.3204C42.8383 34.5182 44.2663 32.9762 45.1271 31.3913C45.4902 30.7229 45.4872 29.4951 44.0444 29.4951H40.3993C39.985 29.4951 39.6017 29.7149 39.3923 30.0725Z",
    fill: "url(#paint25_linear_592_6619)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 778",
    d: "M39.3923 30.0725L36.9043 34.3223L40.414 35.3204C42.8383 34.5182 44.2663 32.9762 45.1271 31.3913C45.4902 30.7229 45.4872 29.4951 44.0444 29.4951H40.3993C39.985 29.4951 39.6017 29.7149 39.3923 30.0725Z",
    fill: "url(#paint26_linear_592_6619)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 169"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38.3624,
    cy: 39.7456,
    r: 5.8622,
    fill: "url(#paint27_linear_592_6619)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.3624,
    cy: 39.7456,
    r: 5.8622,
    fill: "url(#paint28_linear_592_6619)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 170",
    cx: 38.3624,
    cy: 39.7456,
    rx: 5.06909,
    ry: 5.06909,
    fill: "url(#paint29_linear_592_6619)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 171"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.3624,
    cy: 39.7456,
    rx: 4.42529,
    ry: 4.42529,
    fill: "url(#paint30_linear_592_6619)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.3624,
    cy: 39.7456,
    rx: 4.42529,
    ry: 4.42529,
    fill: "url(#paint31_radial_592_6619)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.3624,
    cy: 39.7456,
    rx: 4.42529,
    ry: 4.42529,
    fill: "url(#paint32_radial_592_6619)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.3624,
    cy: 39.7456,
    rx: 4.42529,
    ry: 4.42529,
    fill: "url(#paint33_radial_592_6619)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M39.1863 38.8956L39.7974 37.8395C39.8983 37.6615 39.8983 37.4479 39.7974 37.2699C39.6965 37.0919 39.5067 36.9851 39.3049 36.9851H37.5012C37.1867 36.9851 36.9316 37.2402 36.9316 37.5547C36.9316 37.8692 37.1867 38.1243 37.5012 38.1243H37.8884C38.0805 38.1243 38.2008 38.332 38.1052 38.4987L37.8809 38.8897C37.8038 38.9846 37.7563 39.1092 37.7563 39.2397C37.7563 39.5542 38.0115 39.8093 38.3259 39.8093C38.6819 39.8093 38.9727 40.1001 38.9727 40.4561C38.9727 40.8121 38.6819 41.1028 38.3259 41.1028C38.053 41.1028 37.8097 40.9307 37.7207 40.6756C37.6139 40.3789 37.2936 40.2306 36.9969 40.3315C36.7002 40.4383 36.546 40.7587 36.6528 41.0553C36.9079 41.7614 37.5784 42.236 38.3259 42.236C39.3049 42.236 40.1059 41.441 40.1059 40.4561C40.1 39.7797 39.7321 39.1982 39.1863 38.8956Z",
    fill: "#6C3F48"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_592_6619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.25 12.5) rotate(131.878) scale(58.423)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474827,
    stopColor: "#FFB02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F70A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_592_6619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24 17.75) rotate(101.31) scale(26.7699 34.2871)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.787821,
    stopColor: "#F59639",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972509,
    stopColor: "#FF7DCE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_592_6619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27 20) rotate(135) scale(61.5183)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314853,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_592_6619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24 24.5) rotate(77.692) scale(42.2204)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.507903,
    stopColor: "#7D6133",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#715B32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_592_6619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.75 23.75) rotate(55.7131) scale(19.9703 14.4755)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB847",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_592_6619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.75 26) rotate(9.86581) scale(17.5089)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA64B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.900412,
    stopColor: "#FFAE46",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_592_6619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.25 21.5) rotate(43.9708) scale(88.5794)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.185425,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_592_6619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.9535 18.6128) rotate(-10.3912) scale(10.6064 7.82798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1A227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5A72C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_592_6619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.4754 15.3922) rotate(103.681) scale(3.09762 2.28617)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7982E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E39632",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_592_6619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.0477 16.0348) scale(2.0755)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D28118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D68623",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_592_6619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3123 14.2789) rotate(45.9878) scale(3.36161 1.15173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D28118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D68623",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_592_6619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.3659 13.7052) rotate(9.61849) scale(3.17465 1.30322)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D28118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D68623",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_592_6619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.0712 14.3958) rotate(65.4048) scale(3.61797 1.81327)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE7227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C67A2A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_592_6619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.319 13.3646) rotate(29.8052) scale(2.84532 2.10214)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D07E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D98833",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_592_6619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.6564 13.3646) rotate(-8.79514) scale(3.10468 2.37576)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D88431"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF8231",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_592_6619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.5417 15.0749) rotate(-66.0375) scale(3.87827 2.66036)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA8924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8924",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_592_6619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.3057 15.2539) rotate(90) scale(4.78125 6.46571)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.307692,
    stopColor: "#452A3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626374,
    stopColor: "#594052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#482C40"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_592_6619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.7588 15.2539) rotate(90) scale(4.78125 6.46571)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.307692,
    stopColor: "#452A3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626374,
    stopColor: "#594052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#482C40"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_592_6619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.5 36.5) rotate(-90) scale(13.5 27)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F70A8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89029C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_592_6619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.25 23) rotate(138.576) scale(17.0037)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECCDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_592_6619",
    x1: 24,
    y1: 28.5547,
    x2: 24,
    y2: 30.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4DFFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865521,
    stopColor: "#FFB8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA7CE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_592_6619",
    x1: 25.5911,
    y1: 30.5,
    x2: 23.6959,
    y2: 36.9257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECCDFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_592_6619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.6448 34.9089) rotate(-123.321) scale(2.68587 10.0306)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3669D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3669D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_592_6619",
    x1: 32.8401,
    y1: 29.1805,
    x2: 33.8875,
    y2: 31.7882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D89EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D89EC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_592_6619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.9359 34.9089) rotate(-57.2648) scale(1.77873 3.90164)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3669D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3669D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_592_6619",
    x1: 43.7406,
    y1: 29.1805,
    x2: 42.6932,
    y2: 31.7882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D89EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D89EC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_592_6619",
    x1: 38.1883,
    y1: 32.1211,
    x2: 38.3853,
    y2: 32.2298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A6DD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A6DD8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_592_6619",
    x1: 42.8841,
    y1: 36.7151,
    x2: 37.4304,
    y2: 41.7015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6BC7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A76740"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_592_6619",
    x1: 36.314,
    y1: 45.8927,
    x2: 37.636,
    y2: 38.2262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B05B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B05B5B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_592_6619",
    x1: 42.9811,
    y1: 38.8598,
    x2: 38.3624,
    y2: 38.8598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD8858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D28D59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_592_6619",
    x1: 35.5849,
    y1: 40.8955,
    x2: 42.9496,
    y2: 38.6671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D38E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE794E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_592_6619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.0417 39.0747) rotate(156.644) scale(6.64943 5.66604)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.837399,
    stopColor: "#E5AC75",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5AC75"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_592_6619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.7972 40.2704) rotate(-41.2938) scale(5.22992 5.02174)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.909611,
    stopColor: "#B36441",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B36441"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_592_6619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.2348 39.377) rotate(37.9308) scale(4.9236 5.57961)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.925972,
    stopColor: "#AB662B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB662B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyThirdPrice);
export default __webpack_public_path__ + "static/media/daily_third_price.00896449c606e1a98a1e4423d0d7b086.svg";
export { ForwardRef as ReactComponent };